import { render, staticRenderFns } from "./ResumeQuote.vue?vue&type=template&id=8cdb777a&scoped=true"
import script from "./ResumeQuote.vue?vue&type=script&lang=js"
export * from "./ResumeQuote.vue?vue&type=script&lang=js"
import style0 from "./ResumeQuote.vue?vue&type=style&index=0&id=8cdb777a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdb777a",
  null
  
)

export default component.exports